/**
 *  分模块翻译，方便维护
 *  lang/zh-cn/module/portal/sku.js
 */

export default {
  "sku": {
    "pallets":"盘位",
    "accurate":"精准",
    "parameters":"参数",
    "inv_clas":"库存分类",
    // 展开
    "non_std_lstg":"非标挂盘，请自查型号/厂牌及批次/货期，并联系产品经理更新产品库",
    "eol":"停产",
    "yes":"是",
    "no":"否",
    "data_sheet":"数据手册",
    "item":"商品号",
    "catalog":"目录号",
    "offers":"优惠",
    "founding":"成立",
    "account":"开户",
    "refund":"退货",
    "sample":"样片",
    "special_price":"特价",
    "moq":"起订",
    "mpq":"增量",
    "free_shipping":"包邮",
    "subtotal":"小计",
    "group_buy":"拼团",
    "buy_now":"立即买入",
    "sell_now":"立即卖出",
    "add_to_cart":"加入买卖车",
    // 拼团
    "group_buy_s_p":"拼团特价",
    "time":"计时",
    "start_at":"距离开始",
    "end_at":"距离结束",
    "ended":"拼团已结束",
    "join_group":"参团",
    "progress":"进度",
    "joined_group":"人已参团",
    "rem_g_s_b":"剩余可拼数",
    "full":"整",
  }
};